import { render, staticRenderFns } from "./DashboardEventItem.vue?vue&type=template&id=2570a662"
import script from "./DashboardEventItem.vue?vue&type=script&lang=js"
export * from "./DashboardEventItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports